import type { CaseFieldValues } from "../model/caseReview";
import type { CollectionSpec } from "../constants/caseReviewSections";

/** Reads a coded field's label rather than its stored id, for a title that says something. */
export type RecordOptionLabel = (property: string) => string | undefined;

/**
 * What one record is called on screen.
 *
 * <p>The registry's `title` when the row has the values to make one, and `<item> <n>` when it does
 * not — a freshly added record has nothing to name it yet. Extracted so the chip strip and the
 * route modal's missing-field list call a record the same thing; two copies of this would drift
 * the moment a section changed what titles its cards.
 */
export function recordTitle(spec: CollectionSpec, values: CaseFieldValues, index: number,
                            optionLabel: RecordOptionLabel, recordId?: string): string {
  return spec.title(values, optionLabel, recordId) ?? `${spec.labels.item} ${index + 1}`;
}
